<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" v-if="!loading">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="4">
                  <b-form-group
                    label-for="spkb_res"
                    label="Ambil Order Dari SPKB"
                  >
                    <vue-autosuggest
                      v-model="spkbRes.text"
                      @inputout="focusMe"
                      :suggestions="filteredOptions"
                      @input="onInputChange"
                      @selected="onSelected"
                      :input-props="{
                        id: 'spkb_res',
                        placeholder: 'Find SPKB',
                        class: 'form-control',
                      }"
                      :limit="20"
                    >
                      <template slot-scope="{ suggestion }">
                        <span class="my-suggestion-item">
                          {{ suggestion.item.text }}
                        </span>
                      </template>
                    </vue-autosuggest>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-row>
                    <b-col sm="6">
                      <b-form-group label-for="product" label="Pilih Product">
                        <model-select
                          id="product"
                          :options="listProduct"
                          v-model="productId"
                          @input="productSelected"
                          placeholder="-- Harap pilih salah satu --"
                        ></model-select>
                        <!-- <multi-select
                        :options="listProduct"
                        :selected-options="productId"
                        placeholder="-- Harap pilih salah satu --"
                        @select="onOrderNumberSeleceted"
                        ></multi-select> -->
                        <div
                          v-if="productId === null"
                          class="invalid-feedback-custom"
                        >
                          Produk harus di isi.
                        </div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group label-for="qty_plan" label="Qty Plan">
                        <b-form-input
                          id="qty_plan"
                          type="text"
                          v-model="qtyPlan"
                          placeholder="Qty Plan"
                          readonly
                        ></b-form-input>
                        <b-form-invalid-feedback
                          >QTY Plan harus di isi.</b-form-invalid-feedback
                        >
                      </b-form-group>
                    </b-col>
                    <b-col sm="3">
                      <b-form-group label-for="qty_actual" label="Qty Actual">
                        <b-form-input
                          id="qty_actual"
                          type="text"
                          v-model="qtyActual"
                          placeholder="Qty Actual"
                          readonly
                        ></b-form-input>
                        <b-form-invalid-feedback
                          >QTY Plan harus di isi.</b-form-invalid-feedback
                        >
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="3">
                      <b-form-group label-for="qty_move" label="Pindah Qty">
                        <b-form-input
                          id="qty_move"
                          type="number"
                          v-model="moveQty"
                          :max="max"
                          placeholder="Qty Plan"
                        ></b-form-input>
                        <b-form-invalid-feedback
                          >QTY Move harus di isi.</b-form-invalid-feedback
                        >
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="2">&nbsp;</b-col>
                <b-col sm="4">
                  <b-form-group label-for="spkb_des" label="Pindah Ke SPKB">
                    <vue-autosuggest
                      v-model="spkbDes.text"
                      @inputout="focusMe2"
                      :suggestions="filteredOptions2"
                      @input="onInputChange2"
                      @selected="onSelected2"
                      :input-props="{
                        id: 'spkb_des',
                        placeholder: 'Find SPKB',
                        class: 'form-control',
                      }"
                      :limit="20"
                    >
                      <template slot-scope="{ suggestion }">
                        <span class="my-suggestion-item">
                          {{ suggestion.item.text }}
                        </span>
                      </template>
                    </vue-autosuggest>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="12">
                  <b-button
                    size="sm"
                    variant="stack-overflow"
                    class="mr-1 btn-brand"
                    @click="exchangeProcess"
                  >
                    <i class="fa fa-search"></i>
                    <span>Save Exchange SPKB</span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col lg="12" v-else>
        <b-card no-body>
          <loading></loading>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ModelSelect, MultiSelect } from "vue-search-select";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import { required } from "vuelidate/lib/validators";
import globalTable from "../../templates/Table.vue";
import loading from "@/templates/Loading.vue";
import { VueAutosuggest } from "vue-autosuggest";

import _ from "lodash";
import Loading from "../../templates/Loading.vue";
export default {
  name: "spkb-exchange",
  components: {
    globalTable,
    ModelSelect,
    MultiSelect,
    loading,
    VueAutosuggest,
    Loading,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      loading: false,
      customerHistory: [],
      listOrderNumber: [],
      orderNumberOld: [],
      listProduct: [],
      qtyPlan: 0,
      qtyActual: 0,
      moveQty: 0,
      max: 0,
      productId: null,
      spkbRes: {
        text: null,
        value: null,
      },
      spkbDes: {
        text: null,
        value: null,
      },
      filteredOptions: [],
      suggestions: [
        {
          data: [],
        },
      ],
      suggestions2: [
        {
          data: [],
        },
      ],
      filteredOptions2: [],
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {},
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
    init: function () {
      this.loading = false;
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message,
        });
      }
    },
    exchangeProcess: function () {
      this.loading = true;
      if (this.productId === null) {
        alert("Produk Harus di pilih");
      } else {
        if (confirm("Apakah anda ingin menyimpan perubahan ini ?")) {
          if (parseInt(this.moveQty) > parseInt(this.max)) {
            alert(
              "Qty yang ingin di pindahkan tidak boleh lebih besar dari QTY Aktual"
            );
                this.loading = false;
          } else if (
            this.spkbDes.value === null ||
            this.spkbRes.value === null
          ) {
            alert("SPKB harus di pilih");
                this.loading = false;
          } else {
            this.axios
              .post("web/spkb/spkb-exchange-process/", {
                product_id: this.productId,
                spkb_number: this.spkbRes.value,
                tot_qty_actual: this.max,
                qty: this.moveQty,
                spkb_number_destination: this.spkbDes.value,
              })
              .then((response) => {
                if (response.data.status === 2000) {
                  this.showInfoNotification({
                    title: "Pindah SPKB",
                    message: response.data.message,
                  });
                }
              })
              .catch((error) => {
                if (error.response.status === 401) {
                  this.expired(error, "");
                }
              })
              .finally(() => {
                this.loading = false;
                location.reload();
              });
          }
        }
      }
    },
    onSelected(item) {
      if (item === "" || item === undefined || item === null) {
        this.spkbRes.value = null;
        this.spkbRes.text = null;
        return;
      } else {
        this.spkbRes.value = item.item.value;
        this.spkbRes.text = item.item.text;
        this.findOrder(item.item.value);
      }
    },
    focusMe: function (item) {
      if (item === "" || item === undefined || item === null) {
        this.spkbRes.value = null;
        this.spkbRes.text = null;
        return;
      }
    },
    onInputChange(text) {
      if (text === "" || text === undefined || text === null) {
        this.spkbRes.value = null;
        this.spkbRes.text = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-spkb/", { name: text })
          .then((response) => {
            const temp = response.data.data;
            this.suggestions[0].data = temp;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },

    onSelected2(item) {
      if (item === "" || item === undefined || item === null) {
        this.spkbDes.value = null;
        this.spkbDes.text = null;
        return;
      } else {
        this.spkbDes.value = item.item.value;
        this.spkbDes.text = item.item.text;
      }
    },
    focusMe2: function (item) {
      if (item === "" || item === undefined || item === null) {
        this.spkbDes.value = null;
        this.spkbDes.text = null;
        return;
      }
    },
    onInputChange2(text) {
      if (text === "" || text === undefined || text === null) {
        this.spkbDes.value = null;
        this.spkbDes.text = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-spkb/", { name: text })
          .then((response) => {
            const temp2 = response.data.data;
            this.suggestions2[0].data = temp2;
            const filteredData2 = this.suggestions2[0].data;
            this.filteredOptions2 = [
              {
                data: filteredData2,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },

    findOrder(text) {
      this.listProduct = [];
      axios
        .post("web/dropdown/find-order/", { name: text })
        .then((response) => {
          this.listProduct = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {});
    },
    productSelected(items, lastSelectItem) {
      const temp = items.split("#");
      this.qtyPlan = temp[1];
      this.qtyActual = temp[2];
      this.max = temp[2];
      //this.orderNumberOld = items;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.demo {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

input {
  width: 260px;
  padding: 0.5rem;
}

.autosuggest__results > ul {
  width: 100%;
  color: rgba(30, 39, 46, 1);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 0.5rem 0;
}
.autosuggest__results > ul > li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}
.autosuggest__results > ul > li:hover {
  cursor: pointer;
}

.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}

#autosuggest {
  width: 100%;
  display: block;
}
.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178, 0.2);
}
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  font-family: monospace;
  font-size: 20px;
  border: 1px solid #616161;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  overflow: scroll;
  max-height: 200px;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results_item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results_title {
  border-top: none;
}

.autosuggest__results .autosuggest__results_title {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results_item:active,
.autosuggest__results .autosuggest__results_item:hover,
.autosuggest__results .autosuggest__results_item:focus,
.autosuggest__results
  .autosuggest__results_item.autosuggest__results_item-highlighted {
  background-color: #b6adad;
}
</style>